import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Flex,
  Input,
  PaginationProps,
  Table,
  TableColumnsType,
  DatePicker,
  notification,
} from "antd";
import {
  Calendar2,
  DocumentDownload,
  ExportSquare,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import "./style.scss";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { mixPostV1 } from "../../services/mixin";
// @ts-ignore
import * as XLSX from "xlsx-js-style";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { RangePickerProps } from "antd/es/date-picker";
import MachineIncomeView from "./Components/MachineIncomeView";

const { RangePicker } = DatePicker;

const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current > dayjs().endOf("day");
};

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

interface DataType {
  key: React.Key;
  date: string;
  name: string;
  staff_name: string;
  shift: string;
  totalin: string;
  totalout: string;
  profit: number;
  statusprofit: number;
  report_id: number;
}

interface ExportMachine {
  infoReport: {
    report_id: number;
    date_report: string;
    staff_id: number;
    staff_name: string;
    total_in: number;
    total_out: number;
    profit: number;
    shift: number;
    date_edit: string;
    out_cashout: number;
    store_name: string;
    dateExport: string;
  };
  listBegin: {
    rd_id: number;
    machine_id: number;
    machine_number: number;
    img_machine: string;
    in_number: number;
    out_number: number;
    report_id: number;
  }[];
  listEnd: {
    rd_id: number;
    machine_id: number;
    machine_number: number;
    img_machine: string;
    in_number: number;
    out_number: number;
    report_id: number;
    is_hidden: number;
  }[];
  profit: {
    machine_id: number;
    machine_number: number;
    in_number: number;
    out_number: number;
    profit: number;
  }[];
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const ReportTotalIncome: React.FC = () => {
  // GET LIST
  const navigate = useNavigate();
  const can_view_machine_income =
    localStorage.getItem("can_view_machine_income") ?? "0";
  const [isShow, SetIsShow] = useState(false);
  const [dataView, SetDataView] = useState(false);
  const [exportingId, setExportingId] = useState<number | null>(null);
  const columns: TableColumnsType<DataType> = [
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "Time",
      dataIndex: "date",
    },
    {
      title: "Shift",
      dataIndex: "shift",
    },
    // {
    //   title: 'Machine name',
    //   dataIndex: 'name',
    // },
    {
      title: "Staff",
      dataIndex: "staff_name",
    },
    {
      title: "Total in (USD)",
      dataIndex: "totalin",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
    {
      title: "Total out (USD)",
      dataIndex: "totalout",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
    {
      title: "Out-Cashout Different",
      dataIndex: "out_cashout",
      align: "right",
      render: (text) => (
        <div className="ctrl-td-profit">
          <span className={`${Number(text) >= 0 ? "status-1" : ""}`}>
            {text}
          </span>
        </div>
      ),
    },
    {
      title: "Profit (USD)",
      dataIndex: "profit",
      align: "right",
      render: (text) => (
        <div className="ctrl-td-profit">
          <span className={`${Number(text) >= 0 ? "status-1" : "status-2"}`}>
            {text}
          </span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record: any) => (
        <Flex align="center" gap={4}>
          <Button
            icon={<EyeOutlined />}
            className="rs-button"
            onClick={() => {
              SetIsShow(true);
              SetDataView(record);
            }}
          />
          <Button
            icon={<DocumentDownload />}
            className="rs-button edit"
            loading={exportingId === record.report_id}
            onClick={() => getExportMachine(record.report_id)}
          />
        </Flex>
      ),
      width: 132,
      // hidden: currentTab === '1'
    },
  ];
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [finalTotal, setFinalTotal] = useState<{
    dateReport: string;
    totalIn: number;
    totalOut: number;
    profit: number;
  }>({ dateReport: "", totalIn: 0, totalOut: 0, profit: 0 });

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchKey?: string;
    fromDate?: string;
    toDate?: string;
    searchMachineName?: string;
  }>({
    limit: 10,
    page_number: 1,
  });

  const exportDetailMachineExcel = (data: ExportMachine) => {
    try {
      const {
        infoReport = {} as any,
        listBegin = [],
        listEnd = [],
        profit = [],
      } = data;

      const sumBeginIn = listBegin.reduce(
        (acc, curr) => acc + (curr.in_number || 0),
        0,
      );
      const sumBeginOut = listBegin.reduce(
        (acc, curr) => acc + (curr.out_number || 0),
        0,
      );
      const sumEndIn = listEnd.reduce(
        (acc, curr) => acc + (curr.in_number || 0),
        0,
      );
      const sumEndOut = listEnd.reduce(
        (acc, curr) => acc + (curr.out_number || 0),
        0,
      );
      const sumTotalIn = profit.reduce(
        (acc, curr) => acc + (curr.in_number || 0),
        0,
      );
      const sumTotalOut = profit.reduce(
        (acc, curr) => acc + (curr.out_number || 0),
        0,
      );
      const sumProfit = profit.reduce(
        (acc, curr) => acc + (curr.profit || 0),
        0,
      );

      const sheetData = [
        ["Store Name", infoReport.store_name || ""],
        ["Date", infoReport.dateExport || ""],
        ["Employee", infoReport.staff_name || ""],
        [
          "Session",
          `Shift ${infoReport.shift || ""} - ${infoReport.date_report || ""}`,
        ],
        [
          "Begin In($)",
          sumBeginIn,
          "Begin Out($)",
          sumBeginOut,
          "Total Out",
          sumTotalOut,
        ],
        [
          "End In($)",
          sumEndIn,
          "End Out($)",
          sumEndOut,
          "Total In",
          sumTotalIn,
        ],
        [],
        ["Machine Report"],
        ["Machine", "Begin", "", "End", "", "Total In", "Total Out", "Profit"],
        ["", "In", "Out", "In", "Out", "", "", ""],
      ];

      const machineIds = Array.from(
        new Set([
          ...listBegin.map((b) => b.machine_id),
          ...listEnd.map((e) => e.machine_id),
          ...profit.map((p) => p.machine_id),
        ]),
      );

      const getMachineNumber = (mId: number) => {
        const found: any =
          profit.find((p) => p.machine_id === mId) ||
          listBegin.find((b) => b.machine_id === mId) ||
          listEnd.find((e) => e.machine_id === mId);
        return found ? found.machine_number : mId;
      };

      const sortedMachineIds = machineIds.sort((a, b) => {
        const numA = Number(getMachineNumber(a)) || 0;
        const numB = Number(getMachineNumber(b)) || 0;
        return numA - numB;
      });

      sortedMachineIds.forEach((mId) => {
        const beginItem: any = listBegin.find((b) => b.machine_id === mId) || {
          in_number: 0,
          out_number: 0,
        };
        const endItem: any = listEnd.find((e) => e.machine_id === mId) || {
          in_number: 0,
          out_number: 0,
        };
        const profitItem: any = profit.find((p) => p.machine_id === mId) || {
          in_number: 0,
          out_number: 0,
          profit: 0,
        };

        const begin_in = beginItem.in_number || 0;
        const begin_out = beginItem.out_number || 0;
        const end_in = endItem.in_number || 0;
        const end_out = endItem.out_number || 0;
        const total_in = profitItem.in_number || 0;
        const total_out = profitItem.out_number || 0;
        const profit_val = profitItem.profit || 0;

        const mNumber =
          profitItem.machine_number ||
          beginItem.machine_number ||
          endItem.machine_number ||
          mId;
        const displayMachineName =
          typeof mNumber === "number" || !isNaN(Number(mNumber))
            ? `Machine ${mNumber}`
            : mNumber || `Machine ${mId}`;

        sheetData.push([
          displayMachineName,
          begin_in,
          begin_out,
          end_in,
          end_out,
          total_in,
          total_out,
          profit_val,
        ]);
      });

      sheetData.push([
        "Total",
        sumBeginIn,
        sumBeginOut,
        sumEndIn,
        sumEndOut,
        sumTotalIn,
        sumTotalOut,
        sumProfit,
      ]);

      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

      const merges = [
        { s: { r: 7, c: 0 }, e: { r: 7, c: 7 } },
        { s: { r: 8, c: 0 }, e: { r: 9, c: 0 } },
        { s: { r: 8, c: 1 }, e: { r: 8, c: 2 } },
        { s: { r: 8, c: 3 }, e: { r: 8, c: 4 } },
        { s: { r: 8, c: 5 }, e: { r: 9, c: 5 } },
        { s: { r: 8, c: 6 }, e: { r: 9, c: 6 } },
        { s: { r: 8, c: 7 }, e: { r: 9, c: 7 } },
      ];
      worksheet["!merges"] = merges;

      const wscols = [
        { wch: 18 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
      ];
      worksheet["!cols"] = wscols;

      // Apply bold style to info headers in rows 1 to 6 (r = 0 to 5)
      for (let r = 0; r <= 5; r++) {
        if (r >= 0 && r <= 3) {
          const cellRef = XLSX.utils.encode_cell({ r, c: 0 });
          if (worksheet[cellRef]) {
            worksheet[cellRef].s = { font: { bold: true } };
          }
        } else if (r === 4 || r === 5) {
          for (const c of [0, 2, 4]) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (worksheet[cellRef]) {
              worksheet[cellRef].s = { font: { bold: true } };
            }
          }
        }
      }

      const startRow = 7;
      const endRow = sheetData.length - 1;
      const startCol = 0; // A
      const endCol = 7; // H

      for (let r = startRow; r <= endRow; r++) {
        for (let c = startCol; c <= endCol; c++) {
          const cellRef = XLSX.utils.encode_cell({ r, c });
          if (!worksheet[cellRef]) {
            worksheet[cellRef] = { t: "s", v: "" };
          }
          const isHeaderOrTitle = r === 7 || r === 8 || r === 9;
          const isTotalRow = r === endRow;
          worksheet[cellRef].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: isHeaderOrTitle
              ? { horizontal: "center", vertical: "center" }
              : undefined,
            font: isHeaderOrTitle || isTotalRow ? { bold: true } : undefined,
          };
        }
      }

      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Machine Report");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const dataBlob: Blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      const link: HTMLAnchorElement = document.createElement("a");
      link.href = window.URL.createObjectURL(dataBlob);
      const filename = `Machine_Report_${infoReport.store_name || "Detail"}_${infoReport.date_report || dayjs().format("YYYYMMDD")}.xlsx`;
      link.download = filename;
      link.click();

      openNotification("success", "Export successful!");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      openNotification("error", "Oops, something went wrong during export!");
    }
  };

  const getExportMachine = async (reportId: number) => {
    setExportingId(reportId);
    try {
      const res = await mixPostV1(
        "/api/webAdmin/export_gDetailReportMachineIncome.php",
        { report_id: reportId },
      );
      if (res.status === 1 && res.data) {
        exportDetailMachineExcel(res.data);
      } else {
        openNotification("warning", res.message || "No data");
      }
    } catch (error) {
      console.error(error);
      openNotification("error", "Oops, something went wrong!");
    } finally {
      setExportingId(null);
    }
  };

  const getItems = async () => {
    setTableLoading(true);
    const res = await mixPostV1(
      "/api/webAdmin/gReportMachineIncome.php",
      params,
    );

    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any, index: number) =>
        result.push({
          ...item,
          key: index,
          date: item.date_report,
          profit: item.profit,
          name: item.machineIdName,
          totalin: item.total_in,
          totalout: item.total_out,
        }),
      );
      const total = res.total;
      setItems({
        ...items,
        list: result,
        total: total,
      });
      setTableLoading(false);
      // setFinalTotal(res.finalTotal)
    }
  };

  useEffect(() => {
    if (Number(can_view_machine_income) === 0) {
      navigate("/");
    }
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchMachineName: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };

  // On Date Change
  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[],
  ) => {
    if (dates) {
      setParams({
        ...params,
        page_number: 1,
        fromDate: dateStrings[0],
        toDate: dateStrings[1],
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        fromDate: "",
        toDate: "",
      });
    }
  };
  // END SEARCH

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gReportMachineIncome.php",
        customParams,
      );

      if (res.status === 1) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Time: item.date_report,
        Shift: item.shift,
        Staff: item.staff_name,
        "Total in (USD)": item.total_in,
        "Total out (USD)": item.total_out,
        "Profit (USD)": item.profit,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Machine Income Report"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="report-machine-income-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Report" },
            { title: "Machine Income" },
          ]}
          title="Machine Income"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by name"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input t-input-ctrl table-filter-block__search"
            allowClear
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
          />

          <RangePicker
            allowClear
            className="rs-range-picker"
            suffixIcon={<Calendar2 size={20} />}
            separator={<LineOutlined />}
            placeholder={["From date", "To date"]}
            disabledDate={disabledDate}
            onChange={onRangeChange}
          />

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto t-h40"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <div className="t-table-block">
          <Table
            columns={columns}
            dataSource={items.list}
            className="rs-table table-text-nowrap match-height"
            showSorterTooltip={false}
            loading={tableLoading}
            scroll={{ x: true }}
            // summary={() => (
            //   <Table.Summary fixed>
            //     <Table.Summary.Row>
            //       <Table.Summary.Cell index={0}>Final Total <br /> { finalTotal.dateReport ? `(${finalTotal.dateReport})` : '' }</Table.Summary.Cell>
            //       <Table.Summary.Cell index={1}></Table.Summary.Cell>
            //       <Table.Summary.Cell index={2}></Table.Summary.Cell>
            //       <Table.Summary.Cell index={3}>{ numberFormat(finalTotal.totalIn) }</Table.Summary.Cell>
            //       <Table.Summary.Cell index={4}>{ numberFormat(finalTotal.totalOut) }</Table.Summary.Cell>
            //       <Table.Summary.Cell index={5}>{ numberFormat(finalTotal.profit) }</Table.Summary.Cell>
            //       <Table.Summary.Cell index={6}></Table.Summary.Cell>
            //     </Table.Summary.Row>
            //   </Table.Summary>
            // )}
            pagination={{
              current: params.page_number,
              pageSize: params.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange(e),
            }}
            onChange={onTableChange}
          />
        </div>
        <MachineIncomeView
          isShow={isShow}
          dataView={dataView}
          onPopupClose={() => SetIsShow(false)}
        />
      </Layout>
    </>
  );
};

export default ReportTotalIncome;
